export default __webpack_public_path__ + "static/media/4-1.3ffd95d7.webp";